import React from 'react';

const ListActionSubheader = (props) => {
  return (
    <div className="list-subheader mt-3">
      <h4 className="list-subheader__title text-muted">
        <small>{props.title}</small>
      </h4>
      {props.children}
    </div>
  );
};

export default ListActionSubheader;
